<template>
    <div>

   
          <base-navigation></base-navigation>

    <div class="send-sms">
      <h2>Send SMS to Defaulters</h2>
      <form @submit.prevent="sendSms">
        <!-- <div class="form-group">
          <label for="message">Message:</label>
          <textarea id="message" v-model="message" required></textarea>
        </div> -->
  
        <div class="form-group">
            <select class="form-control" v-model="case_no">
                          <!-- <textarea id="message" v-model="message" required></textarea> -->

                  <option disabled value="">select Gender</option>
                  <option>case_36</option>
                  <option>Case_37</option>
                  <option>Case_38</option>
                  <option>case_39</option>
                  <option>Case_40</option>
                  <option>case_41</option>
                  <option>Case_42</option>
                </select>
        </div>
  
        <button type="submit" :disabled="loading">
          {{ loading ? "Sending..." : "Send SMS" }}
        </button>
  
        <p v-if="responseMessage" class="response">{{ responseMessage }}</p>
      </form>
    </div>
</div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        case_no: "",
        responseMessage: "",
        loading: false,
      };
    },
    methods: {
      async sendSms() {
        if (!this.case_no) {
          this.responseMessage = "Please fill in all fields.";
          return;
        }
  
        this.loading = true;
        this.responseMessage = "";
  
        try {
          const token = localStorage.getItem("token"); // Retrieve token from storage
          console.log(token)
  
          const response = await axios.post(
            "https://api.roberms.com/gafwa/send/defaulters/sms",
            {
              case_no: this.case_no,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
  
          this.responseMessage = response.data.message;
          this.case_no = "";
        } catch (error) {
          this.responseMessage = error.response.data.message;
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .send-sms {
    max-width: 400px;
    margin: auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #f9f9f9;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    font-weight: bold;
  }
  
  textarea,
  input {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  button {
    width: 100%;
    padding: 10px;
    border: none;
    background-color: #007bff;
    color: white;
    font-size: 16px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .response {
    margin-top: 10px;
    font-weight: bold;
    color: green;
  }
  </style>
  